import { count } from "src/api/accounts";

const getInitialState = () => {
  return {
    counts: {
      pod_rejected: {
        Invoices: 0,
      },
      pod_pending: {
        Invoices: 0,
      },
      pod_received: {
        Invoices: 0,
      },
      pod_accepted: {
        Invoices: 0,
      },
      qc_rejected: {
        Invoices: 0,
      },
      qc_received: {
        Invoices: 0,
      },
      qc_accepted: {
        Invoices: 0,
      },
      completed: {
        Invoices: 0,
        EWayBills: 0,
        CreditNotes: 0,
        DebitNotes: 0,
      },
      pending: {
        Invoices: 0,
        EWayBills: 0,
        CreditNotes: 0,
        DebitNotes: 0,
      },
      in_progress: {
        EWayBills: 0,
        CreditNotes: 0,
        DebitNotes: 0,
      },
    },
  };
};

export const useAccountStore = defineStore("account", () => {
  let state = reactive(getInitialState());

  const getCounts = async (options = {}) => {
    try {
      const response = await count(options);

      let tempCounts = {};

      if (response.data?.data) {
        const invoice_stages = [
          "pod_pending",
          "pod_received",
          "pod_rejected",
          "pod_accepted",
          "qc_received",
          "qc_rejected",
          "qc_accepted",
        ];
        const status_cds = ["completed", "in_progress", "pending"];

        const tabs = {
          Invoices: [...status_cds, ...invoice_stages],
          EWayBills: [...status_cds],
          DebitNotes: [...status_cds],
          CreditNotes: [...status_cds],
        };

        const activeTabCollectionMappings = {
          invoices: "Invoices",
          "e-way-bills": "EWayBills",
          "credit-notes": "CreditNotes",
          "debit-notes": "DebitNotes",
        };

        [...status_cds, ...invoice_stages].forEach((status_cd) => {
          const response_status_cd = response.data.data[status_cd];

          tempCounts[status_cd] = {};

          const currentTab = options?.params?.activeTabs?.split(",")[0] || [
            "invoices",
          ];

          Object.keys(tabs).forEach((tab) => {
            if (tabs[tab].includes(status_cd)) {
              tempCounts[status_cd][tab] =
                (response_status_cd?.[tab] >= 0 && response_status_cd?.[tab]) ||
                (activeTabCollectionMappings[currentTab] !== tab &&
                  state.counts?.[status_cd]?.[tab] >= 0 &&
                  state.counts?.[status_cd]?.[tab]) ||
                0;
            }
          });
        });
      }

      state.counts = tempCounts;

      return response;
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const reset = () => {
    Object.assign(state, getInitialState());
  };

  return { ...toRefs(state), getCounts, reset };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAccountStore, import.meta.hot));
}
